module.exports = __webpack_public_path__ + "static/media/Online Learning.25d27e7e.png";